import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import {
  dateRangeValueConverter,
  formatDateTimeStamp,
  isLargeScreen,
} from '../../../../../global.variable';
import { DatetimePickerComponent } from '../../../../shared/components/datetime-picker/datetime-picker.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { JobsService } from '../../jobs/jobs.service';
import { UsersService } from '../users.service';

@Component({
  selector: 'gtapp-user-stats',
  templateUrl: './user-stats.html',
  styleUrl: './user-stats.scss',
  standalone: false,
})
export class UserStats implements OnInit, OnDestroy {
  largeView = isLargeScreen;

  selectedGuardUser: any;

  assigneeListData: any = {};

  dateRange: any;
  dateRangeValue: string = '';

  otherParamsUserStatData: any = { paginationData: true };
  stickyHeader = {
    'position': 'sticky',
    'top': '0',
    'background-color': 'var(--bs-table-bg)',
    'white-space': 'nowrap',
    'left': '0',
    'z-index': 20,
  };
  userStatBreakDownKeysHours: any = {};
  userStatBreakDownKeysCount: any = {};

  tableDetailUserHours: any = [
    {
      header: 'DATE',
      name: 'date',
      datetimeObj: true,
      sortKey: 'date',
      dateTimeFormat: 'd MMM y',
      sortOrder: 'desc',
      tableColumnStyle: {
        ...this.stickyHeader,
        'z-index': 10,
      },
      tableHeaderStyle: this.stickyHeader,
    },
  ];
  tableDetailUserCount: any = [
    {
      header: 'DATE',
      name: 'date',
      datetimeObj: true,
      sortKey: 'date',
      dateTimeFormat: 'd MMM y',
      sortOrder: 'desc',
      tableColumnStyle: {
        ...this.stickyHeader,
        'z-index': 10,
      },
      tableHeaderStyle: this.stickyHeader,
    },
  ];
  completedTaskStats: any = {};

  paginationSubjects: { [key: string]: Subject<any> } = {};

  clockedInOutTimes: any = {};

  clockedInDurationPulledEvents: number = 0;

  userStatsDataDictHours: any = {};
  userStatsHoursList: any = [];

  userStatsDataDictCount: any = {};
  userStatsCountList: any = [];

  totalCountDictHours: any = {};
  totalCountListDataHours: any = [];

  totalCountDictCount: any = {};
  totalCountListDataCount: any = [];

  tableDetailUserCountKeys = new Set();
  tableDetailUserHoursKeys = new Set();

  showDataType: 'count' | 'hours' = 'count';

  constructor(
    private userService: UsersService,
    private toasterService: ToasterService,
    private spinnerService: LoadingSpinnerService,

    private dialogService: ModalDialogueService,

    private jobService: JobsService,
    private route: ActivatedRoute,
  ) {}
  ngOnInit(): void {
    const uId = this.route.snapshot.queryParamMap.get('uId');
    if (uId) {
      this.onAssigneeSelect({ id: uId });
    }
    const today = new Date();
    today.setDate(new Date().getDate() - 1);

    this.dateRange = {
      start: today,
      end: new Date(),
    };
    this.dateRangeValue = `${dateRangeValueConverter(
      this.dateRange?.start,
    )} - \n ${dateRangeValueConverter(this.dateRange?.end)}`;

    this.getAssignees();
  }
  ngOnDestroy(): void {
    Object.keys(this.paginationSubjects).forEach((statType) => {
      this.paginationSubjects[statType].next(null);
      this.paginationSubjects[statType].complete();
      delete this.paginationSubjects[statType];
    });
  }

  onAssigneeSelect(assignee: any) {
    this.selectedGuardUser = null;
    this.spinnerService.show();
    this.userService
      .getUserById(assignee?.id, {})
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.selectedGuardUser = { ...response?.data };
          this.resetAndCallData();

          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  resetAndCallData() {
    this.userStatsDataDictHours = {};

    this.userStatsDataDictCount = {};

    this.totalCountDictHours = {};

    this.totalCountDictCount = {};

    this.clockedInOutTimes = {};
    this.clockedInDurationPulledEvents = 0;

    this.getUserStats();
  }

  onAssigneeSearch(event: any) {
    if (event.target.value?.length > 0) {
      this.getAssignees({ search_str: event?.target?.value });
    } else {
      this.getAssignees();
    }
  }
  getAssignees(params?: any) {
    this.jobService.getUserList(params).subscribe(async (response: any) => {
      if (response['status'] == 'success') {
        this.assigneeListData = [...response?.data];
      }
    });
  }
  openRangePicker() {
    const dialogRef = this.dialogService.open(DatetimePickerComponent, {
      data: {
        dateRange: this.dateRange,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== 'close') {
        this.dateRange = value;

        this.dateRangeValue = `${dateRangeValueConverter(
          this.dateRange?.start,
        )} - \n ${dateRangeValueConverter(this.dateRange?.end)}`;

        this.resetAndCallData();
      }
    });
  }
  mergeAndSum(obj1: any, obj2: any, source: string, isCount = true) {
    const result: any = { ...obj1 };

    for (const key in obj2) {
      if (!result[key]) result[key] = {};
      else result[key] = { ...result[key] };

      const existingValue = result[key][source] || 0;
      const newValue = obj2[key] || 0;

      result[key][source] = isCount
        ? Math.round(existingValue + newValue)
        : existingValue + newValue;

      const totalDict = isCount
        ? this.totalCountDictCount
        : this.totalCountDictHours;
      if (!(source in totalDict)) totalDict[source] = 0;
      totalDict[source] += isCount
        ? Math.round(newValue)
        : Math.round(newValue);
    }

    return result;
  }

  getUserShiftStats(statType = 'normal_jobs', nextCursor?: string) {
    let reqParams: any = { stat_type: statType };

    if (!this.paginationSubjects[statType])
      this.paginationSubjects[statType] = new Subject();
    if (nextCursor) reqParams.next_cursor = nextCursor;

    this.userService
      .getUserUpdateLog(
        {
          sub_user_id: this.selectedGuardUser?.id,
          event_type: 'user_stats',
          date_range: this.dateRange,
          rows: 25,
          sort_key: this.getSortKeys(statType),
        },
        reqParams,
      )
      .pipe(takeUntil(this.paginationSubjects[statType]))
      .subscribe((response: any) => {
        if (response.status !== 'success') {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response.message,
          });
          this.spinnerService.hide();
          return;
        }

        const responseData = response.data || {};

        const isHours = ['normal_jobs', 'runsheet', 'cp_patrol']?.includes(
          statType,
        );

        if (
          ['completed_jobs', 'checkpoint_scans', 'normal_jobs'].includes(
            statType,
          )
        ) {
          for (const key in responseData) {
            const updatedKey = key.toLowerCase().replace(/\s+/g, '_');
            if (isHours) {
              this.userStatsDataDictHours = this.mergeAndSum(
                this.userStatsDataDictHours,
                responseData[key] || {},
                updatedKey,
                false,
              );
            } else {
              this.userStatsDataDictCount = this.mergeAndSum(
                this.userStatsDataDictCount,
                responseData[key] || {},
                updatedKey,
                true,
              );
            }
          }
        } else {
          let key: string | undefined;
          switch (statType) {
            case 'completed_cp_patrol':
              key = 'CHECKPOINT PATROL';
              break;
            case 'cp_patrol':
              key = 'CHECKPOINT PATROL';
              break;
            case 'runsheet':
              key = 'SCHEDULED PATROL';
              break;
            case 'incidents_sent':
              key = 'INCIDENTS LOGGED';
              break;
            default:
              key = statType;
          }
          if (isHours) {
            this.userStatsDataDictHours = this.mergeAndSum(
              this.userStatsDataDictHours,
              responseData || {},
              key.toLowerCase().replace(/\s+/g, '_'),
              false,
            );
          } else {
            this.userStatsDataDictCount = this.mergeAndSum(
              this.userStatsDataDictCount,
              responseData || {},
              key.toLowerCase().replace(/\s+/g, '_'),
              true,
            );
          }
        }

        this.flattenData(isHours);

        if (response.next_cursor)
          this.getUserShiftStats(statType, response.next_cursor);
        this.spinnerService.hide();
      });
  }

  getSortKeys(statType: string) {
    if (statType === 'completed_jobs')
      return ['completed_date', 'job__job_type_id'];
    if (['completed_cp_patrol', 'incidents_sent'].includes(statType))
      return ['completed_date'];
    if (['checkpoint_scans'].includes(statType))
      return ['completed_date', 'event_action'];
    return ['start_date_time', 'id'];
  }
  flattenData(isHours = true) {
    if (isHours) {
      this.userStatsHoursList = Object.keys(this.userStatsDataDictHours)
        ?.map((date) => {
          const dataDict = this.userStatsDataDictHours[date];

          const excludedKeys = ['clocked_in_hours'];

          const sum = Object.entries(dataDict)
            .filter(([key]) => !excludedKeys.includes(key))
            .reduce((total: number, [, value]: any) => {
              return total + Math.round(Number(value ?? 0));
            }, 0);
          return {
            date,
            ...dataDict,
            total_hours: sum,
          };
        })
        .filter((item) => item.total_hours > 0);
      this.userStatsHoursList.sort(
        (a: any, b: any) =>
          new Date(b.date).getTime() - new Date(a.date).getTime(),
      );
      this.totalCountListDataHours = this.buildListDataFromDict(
        this.totalCountDictHours,
        true,
      );
      this.userStatBreakDownKeysHours = {};
      this.tableDetailUserHours = [
        {
          header: 'DATE',
          name: 'date',
          datetimeObj: true,
          sortKey: 'date',
          dateTimeFormat: 'd MMM y',
          sortOrder: 'desc',
          tableColumnStyle: {
            ...this.stickyHeader,
            'z-index': 10,
          },
          tableHeaderStyle: this.stickyHeader,
        },
      ];
      [...this.tableDetailUserHoursKeys]?.forEach((key: any) => {
        const updatedKey = key.replace(/_/g, ' ').toUpperCase();
        this.tableDetailUserHours.push({
          header: updatedKey,

          nestedValue: (row: any) => {
            return Math.round(row?.[key] || 0);
          },
          sortKey: key,
          tableHeaderStyle: this.stickyHeader,
        });
        this.userStatBreakDownKeysHours[key] = updatedKey;
      });
      this.tableDetailUserHours.push({
        header: 'ROSTERED HOURS',
        name: 'total_hours',
        sortKey: 'total_hours',

        tableHeaderStyle: this.stickyHeader,
      });
      if (
        this.clockedInOutTimes &&
        Object.keys(this.clockedInOutTimes)?.length
      ) {
        const clockedIhHrsIndex = this.tableDetailUserHours?.findIndex(
          (item: any) => item?.header == 'CLOCKED IN HOURS',
        );
        const clockIndex = Math.max(1, clockedIhHrsIndex + 1);

        this.tableDetailUserHours?.splice(clockIndex, 0, {
          header: 'CLOCK IN-OUT',
          tableHeaderStyle: this.stickyHeader,

          nestedValue: (row: any) => {
            const groupedDate = new Date(row?.date);
            groupedDate.setHours(0, 0, 0, 0);
            const clockInList = (
              this.clockedInOutTimes?.[row?.date] || []
            )?.map((item: any) => {
              let returnString = formatDateTimeStamp(
                item?.clocked_in,
                'HH:mm',
                'en_US',
              );
              if (item?.clocked_out) {
                returnString += ' - ';
                const clockedOutAt = new Date(item?.clocked_out);
                clockedOutAt.setHours(0, 0, 0, 0);

                const sameDay = groupedDate.getTime() == clockedOutAt.getTime();

                returnString += formatDateTimeStamp(
                  item?.clocked_out,
                  sameDay ? 'HH:mm' : 'd MMM y HH:mm',
                  'en_US',
                );
              }

              return returnString;
            });

            return clockInList?.join('\n');
          },
        });
      }

      this.otherParamsUserStatData = { ...this.otherParamsUserStatData };
    } else {
      // Count list
      this.userStatsCountList = Object.keys(this.userStatsDataDictCount).map(
        (date) => ({
          date,
          ...this.userStatsDataDictCount[date],
        }),
      );

      this.totalCountListDataCount = this.buildListDataFromDict(
        this.totalCountDictCount,
      );
      // Sort stats by date

      this.userStatsCountList.sort(
        (a: any, b: any) =>
          new Date(b.date).getTime() - new Date(a.date).getTime(),
      );

      this.userStatBreakDownKeysCount = {};
      this.tableDetailUserCount = [
        {
          header: 'DATE',
          name: 'date',
          datetimeObj: true,
          sortKey: 'date',
          dateTimeFormat: 'd MMM y',
          sortOrder: 'desc',
          tableColumnStyle: {
            ...this.stickyHeader,
            'z-index': 10,
          },
          tableHeaderStyle: this.stickyHeader,
        },
      ];
      [...this.tableDetailUserCountKeys]?.forEach((key: any) => {
        const updatedKey = key.replace(/_/g, ' ').toUpperCase();
        this.tableDetailUserCount.push({
          header: updatedKey,

          nestedValue: (row: any) => {
            return Math.round(row?.[key] || 0);
          },
          sortKey: key,
          tableHeaderStyle: this.stickyHeader,
        });
        this.userStatBreakDownKeysCount[key] = updatedKey;
      });
      this.otherParamsUserStatData = { ...this.otherParamsUserStatData };
    }

    this.showDataType = this.userStatsHoursList?.length ? 'hours' : 'count';
  }
  buildListDataFromDict(dict: any, isHours = false) {
    const groupedData: any = {};
    Object.keys(dict).forEach((key) => {
      if (dict[key] > 0) {
        let updatedKey = key.replace(/_/g, ' ').toUpperCase();
        if (!(key in groupedData))
          groupedData[key] = { label: updatedKey, value: 0 };

        if (isHours) {
          this.tableDetailUserHoursKeys.add(key);
        } else {
          this.tableDetailUserCountKeys.add(key);
        }

        groupedData[key]['value'] += dict[key];
      }
    });
    return Object.values(groupedData);
  }
  getUserCompletedTasks() {
    let reqParams: any = { stat_type: 'completed_task_stats' };

    this.userService
      .getUserUpdateLog(
        {
          sub_user_id: this.selectedGuardUser?.id,
          event_type: 'user_stats',
          date_range: this.dateRange,
          rows: 25,
        },
        reqParams,
      )
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.completedTaskStats = response?.data || {};
          if (this.completedTaskStats?.sum_total_tasks) {
            const completed =
              (this.completedTaskStats?.sum_completed_tasks || 0) /
              this.completedTaskStats?.sum_total_tasks;

            const percent = Math.round(completed * 100);

            this.completedTaskStats['percent'] = percent;

            this.completedTaskStats['strokes'] = `${Math.round(percent)},100`;
          }

          this.spinnerService.hide();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
          this.spinnerService.hide();
        }
      });
  }
  getClockedInDurationData(previous?: number) {
    const statType = 'clocked_in_duration';
    let reqParams: any = { stat_type: statType };

    if (!this.paginationSubjects[statType])
      this.paginationSubjects[statType] = new Subject();

    const rowSize = 20;
    let reqBody: any = {
      sub_user_id: this.selectedGuardUser?.id,
      event_type: 'user_stats',
      date_range: this.dateRange,
      rows: rowSize,
    };

    if (previous) reqBody.previous = previous;

    this.userService
      .getUserUpdateLog(reqBody, reqParams)
      .pipe(takeUntil(this.paginationSubjects[statType]))
      .subscribe((response: any) => {
        if (response.status !== 'success') {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response.message,
          });
          this.spinnerService.hide();
          return;
        }

        // Track clock-in/out per day
        const clockedGrouped = response.clock_in_out_grouped || {};
        for (const date in clockedGrouped) {
          if (!this.clockedInOutTimes[date]) this.clockedInOutTimes[date] = [];
          this.clockedInOutTimes[date] = [
            ...(this.clockedInOutTimes[date] || []),
            ...clockedGrouped[date],
          ];
        }

        this.clockedInDurationPulledEvents += response.pulled_item_count || 0;

        // Merge clocked-in hours separately
        const responseData = response.data || {};
        // this.clockedInHoursDataDict = this.mergeAndSum(
        //   this.clockedInHoursDataDict,
        //   responseData,
        //   'clocked_in_hours',
        //   false
        // );

        this.userStatsDataDictHours = this.mergeAndSum(
          this.userStatsDataDictHours,
          responseData || {},
          'clocked_in_hours',
          false,
        );

        this.flattenData();

        // Fetch next batch if needed
        if (this.clockedInDurationPulledEvents < response.total_item_count) {
          this.getClockedInDurationData((previous || 0) + rowSize);
        }

        this.spinnerService.hide();
      });
  }

  getUserStats() {
    // hour related data
    this.getUserShiftStats();
    this.getUserShiftStats('runsheet');
    this.getUserShiftStats('cp_patrol');
    this.getClockedInDurationData();

    // count based info

    this.getUserShiftStats('completed_jobs');
    this.getUserShiftStats('completed_cp_patrol');
    this.getUserShiftStats('incidents_sent');
    this.getUserShiftStats('checkpoint_scans');
    this.getUserCompletedTasks();
  }
  shiftFocus(elementId: string, time: number = 100) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      if (element) {
        element?.focus();
      }
    }, time);
  }
}
